import { Component, OnChanges, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import * as _ from 'lodash';

import { Listview } from '../../model/his-listview.model';

@Component( {
    selector: 'his-listview',
    templateUrl: './his-listview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisListviewComponent implements OnChanges {
    @Input() listviewData: Record<string, Listview>;
    @Input() listviewKeys: string[];
    @Input() customClickHandler = false;
    @Output() btnMoreClicked = new EventEmitter<string>();

    public oneListviews: Listview[] = [];

    ngOnChanges() {
        this.oneListviews = [];

        if ( !_.isEmpty( this.listviewData ) && !_.isEmpty( this.listviewKeys ) ) {
            for ( let listviewKey of this.listviewKeys ) {
                if(this.listviewData[listviewKey]?.totalCount && !this.listviewData[listviewKey].isHidden) {
                    this.oneListviews.push( this.listviewData[listviewKey] );
                }
            }
        }
    }

    /***************** GUI Helper Methoden **********************/

    /* check if a listview column has content or not */
    public isEmptyListviewArray( listviews: Listview[] ): boolean {
        if ( listviews ) {
            for ( let listview of listviews ) {
                if ( listview && listview.listViewData && listview.listViewData.length > 0 ) {
                    return false;
                }
            }
        }
        return true;
    }

    public getListviewKey( listview: Listview ): string {
        return this.listviewKeys.find( lv => this.listviewData[lv] === listview );
    }
}
